import request from "@/utils/request";

export default function resetPwd(id) {
    return request({
        url: `/merchant/agency/resetPwd/${id}`,
        method: 'get',
    })
}